/**
 * The icon for tik tok.
 * https://www.figma.com/design/UWKZEzXYf0Gf5e6sfqsKVC/THRIVE-WORKING-FILE?node-id=8869-84185&m=dev
 */
const IconTikTok = () => {
  return (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.6451 2.86816C15.953 5.47921 17.4307 7.0359 20 7.2015V10.1382C18.5111 10.2818 17.2068 9.80151 15.6899 8.8962V14.3888C15.6899 21.3663 7.97653 23.5468 4.8755 18.5455C2.88278 15.3272 4.10304 9.68006 10.4954 9.45374V12.5506C10.0084 12.6278 9.48786 12.7493 9.01207 12.9094C7.5903 13.3841 6.78425 14.2729 7.00816 15.8406C7.43916 18.8436 13.0255 19.7323 12.5609 13.8644V2.87368H15.6451V2.86816Z"
      fill="currentColor"
      data-testid="icon-tiktok"
    />
  );
};

export default IconTikTok;
